var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 32 32"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M10 12.631c0-.3.136-.588.377-.8a1.38 1.38 0 0 1 .909-.331h9.428c.341 0 .668.12.91.331.24.213.376.5.376.8v.258l-5.672 3.328a.7.7 0 0 1-.328.078.7.7 0 0 1-.328-.078L10 12.89zm0 1.717v5.02c0 .3.136.588.377.8.24.213.568.332.909.332h9.428c.341 0 .668-.12.91-.331.24-.213.376-.5.376-.8v-5.02l-5.08 2.98-.005.003a1.86 1.86 0 0 1-.915.232c-.321 0-.645-.077-.915-.232l-.005-.003z",
  clipRule: "evenodd"
})));
export default SvgIconMail;